import React, { ReactNode } from 'react'
import { useFela } from 'react-fela'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import { IStyle } from 'fela'

interface MessageProps {
  brand: 'error' | 'info' | 'transparent' | 'neutral'
  outline?: 'top' | 'bottom' | 'right' | 'left' | boolean
  children: ReactNode
  withBorderRadius: boolean
  margin?: number
  className?: IStyle
  textAlign?: 'left' | 'center' | 'right' | 'justify'
}

export const Message: React.FC<MessageProps> = ({
  children,
  brand = 'info',
  outline = false,
  withBorderRadius = false,
  margin = 0,
  textAlign = 'left',
  className,
  ...props
}) => {
  const { css } = useFela({ textAlign, brand, outline, withBorderRadius, margin, ...props })

  return (
    <div {...props} className={css([rules.wrapper, className])}>
      {children}
    </div>
  )
}

const rules = {
  wrapper: ({ textAlign, brand, outline, withBorderRadius, margin }: Partial<MessageProps>) => {
    return {
      width: '100%',
      background: outline === true ? 'transparent' : backgrounds[brand as string],
      color: outline === true ? backgrounds[brand as string] : colors[brand as string],
      padding: `${pxTo(15, baseFontSize, 'rem')} ${pxTo(20, baseFontSize, 'rem')}`,
      borderRadius: withBorderRadius === true ? pxTo(ds.get('border.radius.messages'), baseFontSize, 'rem') : 0,
      borderColor: outline === true ? borders[brand as string] : 'transparent',
      borderTopColor: outline === true || outline === 'top' ? borders[brand as string] : 'transparent',
      borderBottomColor: outline === true || outline === 'bottom' ? borders[brand as string] : 'transparent',
      borderLeftColor: outline === true || outline === 'left' ? borders[brand as string] : 'transparent',
      borderRightColor: outline === true || outline === 'right' ? borders[brand as string] : 'transparent',
      borderWidth: outline === false ? 0 : pxTo(1, baseFontSize, 'rem'),
      borderStyle: 'solid',
      marginBottom: pxTo(margin, baseFontSize, 'rem'),
      textAlign: textAlign,
    }
  },
}

const baseFontSize = ds.get('type.baseFontSize')
const backgrounds = {
  error: ds.brand('brightOrange'),
  info: ds.brand('skyBlue'),
  neutral: ds.brand('white'),
  transparent: 'transparent',
}

const colors = {
  error: ds.brand('white'),
  info: ds.brand('white'),
  neutral: ds.brand('blueNight'),
  transparent: ds.brand('white'),
}

const borders = {
  error: ds.brand('brightOrange'),
  info: ds.brand('skyBlue'),
  neutral: ds.brand('greyMedium'),
  transparent: ds.brand('greyMedium'),
}
